import { render, staticRenderFns } from "./SimpleLayout.vue?vue&type=template&id=cfde5f10&"
import script from "./SimpleLayout.vue?vue&type=script&lang=js&"
export * from "./SimpleLayout.vue?vue&type=script&lang=js&"
import style1 from "./SimpleLayout.vue?vue&type=style&index=1&id=cfde5f10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports